// @flow

import RadioGroupReact from './radio_group';

export default RadioGroupReact;